// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --lw-blue-color: #008fff;
}

* {
    margin: 0;
}

.selected-flag::before{
    border: none !important;
    box-shadow: none !important;
}

.dropdown{
    width: 64vw !important;
    min-width: 225px !important;
    max-width: 300px !important;
}

.react-tel-input .form-control.invalid-number {
    border: 1px solid #ff5700 !important;
}

.round {
    border-radius: 200px !important;
}


.phone-input{
    height: 20px !important;
    width: 100% !important;
}

.form-parent { 
    display: flex; 
    align-items: center; 
    flex-direction: column 
}

.form-container {
    display: flex;
    justify-content: center;
    justify-self: center;
    height: fit-content;
    max-width: 500px;

    border: none;
    margin: 10px;

    overflow-y: scroll;
}

.form-component {
    display: flex;
    flex-direction: column;

    border: 0.05rem solid #eaeaea;
    border-radius: 5px;
    min-width: 350px;

    padding: 2.5rem;
}

.form-logo {
    align-self: center;
    margin-bottom: 20px;

    max-height: 100px;
    max-width: 200px;
    height: auto;
    width: auto;
}

.form-terms {
    display: flex;
    align-items: flex-start;
    gap: 8px;

    /* font-size: 1rem; */
    font-size: small;
    text-align: justify;
}

.form-terms > input {
    margin-top: 3px;
}

#submitBtn {
    display: flex;
    justify-content: center;
    align-items: center;
}

.arc {
    border: 2px solid #ffffff;
    border-radius: 50%;
    height: 15px;
    width: 15px;
    border-top-color: transparent;
    animation: rotate 1s infinite linear;
    margin-left: 1em;
	margin-right: 0.5em;
}

@keyframes rotate {
    0%    { transform: rotate(0deg);  }
    100%  { transform: rotate(360deg);  }
}`, "",{"version":3,"sources":["webpack://./src/views/Form/Form.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,+BAA+B;AACnC;;;AAGA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;;IAEhB,YAAY;IACZ,YAAY;;IAEZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;;IAEtB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;;IAEhB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;;IAEnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;;IAER,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,oCAAoC;IACpC,gBAAgB;CACnB,mBAAmB;AACpB;;AAEA;IACI,QAAQ,uBAAuB,GAAG;IAClC,QAAQ,yBAAyB,GAAG;AACxC","sourcesContent":[":root {\n    --lw-blue-color: #008fff;\n}\n\n* {\n    margin: 0;\n}\n\n.selected-flag::before{\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.dropdown{\n    width: 64vw !important;\n    min-width: 225px !important;\n    max-width: 300px !important;\n}\n\n.react-tel-input .form-control.invalid-number {\n    border: 1px solid #ff5700 !important;\n}\n\n.round {\n    border-radius: 200px !important;\n}\n\n\n.phone-input{\n    height: 20px !important;\n    width: 100% !important;\n}\n\n.form-parent { \n    display: flex; \n    align-items: center; \n    flex-direction: column \n}\n\n.form-container {\n    display: flex;\n    justify-content: center;\n    justify-self: center;\n    height: fit-content;\n    max-width: 500px;\n\n    border: none;\n    margin: 10px;\n\n    overflow-y: scroll;\n}\n\n.form-component {\n    display: flex;\n    flex-direction: column;\n\n    border: 0.05rem solid #eaeaea;\n    border-radius: 5px;\n    min-width: 350px;\n\n    padding: 2.5rem;\n}\n\n.form-logo {\n    align-self: center;\n    margin-bottom: 20px;\n\n    max-height: 100px;\n    max-width: 200px;\n    height: auto;\n    width: auto;\n}\n\n.form-terms {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n\n    /* font-size: 1rem; */\n    font-size: small;\n    text-align: justify;\n}\n\n.form-terms > input {\n    margin-top: 3px;\n}\n\n#submitBtn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.arc {\n    border: 2px solid #ffffff;\n    border-radius: 50%;\n    height: 15px;\n    width: 15px;\n    border-top-color: transparent;\n    animation: rotate 1s infinite linear;\n    margin-left: 1em;\n\tmargin-right: 0.5em;\n}\n\n@keyframes rotate {\n    0%    { transform: rotate(0deg);  }\n    100%  { transform: rotate(360deg);  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
